// @flow
import { combineReducers } from "redux"
import { createSelector } from "reselect"

import { servicePackagesSelector } from "booking/services/servicePackages/reducer"
import Price from "common/records/Price"
import priorityBoarding, {
  priorityBoardingFormattedSelector,
  priorityBoardingFormattedToLogSelector,
  priorityBoardingOrderedPriceSelector,
} from "./services/priorityBoarding/reducer"
import insurance, {
  insurancePriceSelector,
} from "booking/services/additionalServices/services/insurance/reducer"
import paidCheckin, {
  getPaidCheckinOrderedPrice,
} from "booking/services/ancillaries3rd/services/paidCheckin/reducer"
import airHelp, {
  airHelpAddedSelector,
  airHelpOrderedPriceSelector,
} from "../ancillaries3rd/services/airHelp/reducer"
import fastTrack, {
  fastTrackFormattedSelector,
  fastTrackOrderedPriceSelector,
} from "../ancillaries3rd/services/fastTrack/reducer"
import blueribbonBags, {
  blueribbonBagsFormattedSelector,
  blueribbonBagsOrderedPriceSelector,
} from "../ancillaries3rd/services/blueribbonBags/reducer"
import generalAncillaries from "../ancillaries3rd/reducer"
import type {
  AdditionalServicesLogFormat,
  AdditionalServicesSaveFormat,
} from "booking/services/additionalServices/types"
import type { State } from "booking/services/types"
import mandatorySeating, {
  getMandatorySeatingPrice,
} from "booking/services/ancillaries3rd/services/mandatorySeating/reducer"
import seatingReducer from "./services/seating/reducer"
import {
  seatingSaveBookingSerializerSelector,
  seatingOrderedPriceSelector,
  isSeatingAddedSelector,
} from "./services/seating/selectors"

const additionalServicesReducer: $FlowFixMe = combineReducers({
  general: generalAncillaries,
  insurance,
  priorityBoarding,
  paidCheckin,
  airHelp,
  fastTrack,
  blueribbonBags,
  mandatorySeating,
  seating: seatingReducer,
})

export default additionalServicesReducer

// Data selectors
// ===
export const getAdditionalServices = (state: State) => state.reservation.additionalServices

// Formatted for Save booking
export const additionalServicesFormattedSelector: $FlowFixMe = createSelector(
  priorityBoardingFormattedSelector,
  airHelpAddedSelector,
  fastTrackFormattedSelector,
  blueribbonBagsFormattedSelector,
  servicePackagesSelector,
  seatingSaveBookingSerializerSelector,
  (
    priorityBoardingFormatted,
    airHelpAdded,
    fastTrackFormatted,
    blueribbonBagsFormatted,
    servicePackagesAdded,
    seatingsFormatted,
  ): AdditionalServicesSaveFormat => {
    // TODO: change once BE accepts service_package=null
    if (servicePackagesAdded.package_type !== "basic") {
      return {
        priority_boarding: priorityBoardingFormatted,
        airhelp_plus: airHelpAdded,
        fast_track: fastTrackFormatted,
        blueribbon_bags: blueribbonBagsFormatted,
        service_package: servicePackagesAdded,
        seating: seatingsFormatted,
      }
    }
    return {
      priority_boarding: priorityBoardingFormatted,
      airhelp_plus: airHelpAdded,
      fast_track: fastTrackFormatted,
      blueribbon_bags: blueribbonBagsFormatted,
      seating: seatingsFormatted,
    }
  },
)
// Formatted for Log
export const additionalServicesFormattedToLogSelector: $FlowFixMe = createSelector(
  priorityBoardingFormattedToLogSelector,
  seatingOrderedPriceSelector,
  isSeatingAddedSelector,
  (
    priorityBoardingFormattedToLog,
    seatingOrderedPrice,
    isSeatingAdded,
  ): AdditionalServicesLogFormat => ({
    priority_boarding: priorityBoardingFormattedToLog,
    seatingPrice: seatingOrderedPrice,
    seatingAdded: isSeatingAdded,
  }),
)

export const getAdditionalServicesPrice: $FlowFixMe = createSelector(
  priorityBoardingOrderedPriceSelector,
  airHelpOrderedPriceSelector,
  fastTrackOrderedPriceSelector,
  blueribbonBagsOrderedPriceSelector,
  getPaidCheckinOrderedPrice,
  insurancePriceSelector,
  getMandatorySeatingPrice,
  seatingOrderedPriceSelector,
  Price.sum,
)
